import _ from 'lodash';
import { SEARCH_KEYWORD, SEARCH_CLOSE_KEYWORD, SEARCH_CLOSE_KEYWORD_ERR, SEARCH_RESULT, SEARCH_RESULT_ERR } from './type';
// import axios from 'axios';
// import { ROOT_URL } from '../../config';

export function closeTerm(keyword) {
    return (dispatch, getState, { axios }) => {
        if (keyword === "") {
            dispatch({
                type: SEARCH_CLOSE_KEYWORD,
                payload: null,
            });
        }
        if (keyword.length >= 2) {
            axios.post(`/api/v2/materials`, { filter: { keyword }, limit: 20, page: 1, sort: "new_arrivals" }, {})
                // axios.get(`/search/close_terms`, {
                // params: {
                //     keyword
                // },
                // headers: {
                //     authorization: localStorage.getItem('token')
                // }
                // })
                .then((response) => {
                    const data = response.data;
                    const result = { items: data ? (data.data.length > 0 ? data.data.slice(0, Math.min(5, data.data.length)) : []) : [] };
                    result.brands = _.uniqBy(_.map(result.items, (i) => { return { brand_en: i.brand_en, image: i.image, link_name: i.link_name, shop_in_shop: i.shop_in_shop } }), (i) => i.brand_en);
                    result.brands = result.brands.slice(0, Math.min(2, result.brands.length));
                    dispatch({
                        type: SEARCH_CLOSE_KEYWORD,
                        payload: result,
                    });
                })
                .catch((error) => {
                    const err_code = error.response?.data?.code || "ERROR.CODE_UNAVAILABLE";
                    dispatch({
                        type: SEARCH_CLOSE_KEYWORD,
                        payload: null,
                    });
                    dispatch({
                        type: SEARCH_CLOSE_KEYWORD_ERR,
                        payload: err_code
                    })
                })
        }

    }
}

export function search(keyword) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: SEARCH_KEYWORD,
            payload: keyword
        });
        dispatch({
            type: SEARCH_RESULT,
            payload: { data: [], count: 0 }
        });
        axios.get(`/search`, {
            params: {
                keyword
            },
            headers: {
                authorization: localStorage.getItem('token')
            }
        })
            .then((response) => {
                // console.log (response);
                dispatch({
                    type: SEARCH_RESULT,
                    payload: response.data
                });
            })
            .catch((error) => {
                const err_code = error.response?.data?.code || "ERROR.CODE_UNAVAILABLE";
                dispatch({
                    type: SEARCH_RESULT_ERR,
                    payload: err_code
                });
                dispatch({
                    type: SEARCH_RESULT,
                    payload: { data: [], count: 0 }
                });
            })
    }
}